const defaultDesign = {
  button_border_radius: 30,
  button_text_color: '',
  custom_form_width: 60,
  footer_alignment: 'center',
  footer_background_color: '',
  footer_color: '',
  footer_padding: 40,
  form_background: 'FFFFFF',
  form_background_image: '',
  form_background_image_fixed: false,
  form_background_image_repeat: false,
  form_background_image_size: 'cover',
  form_background_transparency: 100,
  form_background_type: 'fill',
  form_body_label_color: '',
  form_body_label_transform: 'default',
  form_body_padding: 21,
  form_border_radius: 14,
  form_direction: 'default',
  form_field_background_color: '',
  form_field_border_color: '',
  form_field_border_radius: 4,
  form_field_color: '',
  form_gradient_direction: 'to right',
  form_gradient_end_color: '',
  form_gradient_shape: 'ellipse',
  form_gradient_start_color: '',
  form_gradient_type: 'linear',
  form_layout: 'default_layout',
  header_alignment: 'center',
  header_background_color: '',
  header_color: '',
  header_line_height: '',
  header_padding: 21,
  label_orientation: 'default',
  logo_placement: 'header',
  page_background_blur: '',
  page_background_type: 'fill',
  page_gradient_direction: 'to right',
  page_gradient_end_color: '',
  page_gradient_shape: 'ellipse',
  page_gradient_start_color: '',
  page_gradient_type: 'linear',
  secondary_button_background_color: '',
  secondary_button_color: '',
  theme: 'None',
};

export default defaultDesign;
